
const hashBufferIn = new Float64Array(1);
const hashBufferOut = new Uint32Array(hashBufferIn.buffer);

export { generateHashCode };

function hashCodeNumber(num, initValue) {

  let hash = initValue;
  hashBufferIn[0] = num;

  hash = (hash << 5) - hash + hashBufferOut[0];
  hash = hash & hash;
  hash = (hash << 5) - hash + hashBufferOut[1];
  hash = hash & hash;

  return hash;

}

function hashCodeString(str, initValue) {

  let hash = initValue;

  for (let i = 0; i < str.length; ++i) {

      const symbol = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + symbol;
      // convert to 32 bit integer
      hash = hash & hash; 

  }

  return hash;

}

function generateHashCode(obj, initValue) {

  let hash = initValue;

  switch (typeof obj) {
    case "object":
      if (obj) {
        switch (obj.constructor) {
          case Object:
            for (let prop in obj) {
              hash = generateHashCode(obj[prop], hash);
            }
            break;
          case Int8Array:
          case Uint8Array:
          case Uint8ClampedArray:
          case Int16Array:
          case Uint16Array:
          case Int32Array:
          case Uint32Array:
          case Float32Array:
          case Float64Array:
            for (let j = 0; j < obj.length; ++j) {
              hash = hashCodeNumber(obj[j], hash);
            }
            break;
          case Array:
            for (let j = 0; j < obj.length; ++j) {
              hash = generateHashCode(obj[j], hash);
            }
            break;
          case WebGLUniformLocation:
          case WebGLProgram:
          case WebGLShader:
          case WebGLFramebuffer:
          case WebGLRenderbuffer:
          case WebGLTexture:
          case WebGLBuffer:
            hash = hashCodeNumber(0, hash);
            break;
          default:
            for (let prop in obj) {
              hash = generateHashCode(obj[prop], hash);
            }
            break;
        }
      } else {
        hash = hashCodeNumber(0, hash);
      }
      break;
    case "number":
      hash = hashCodeNumber(obj, hash);
      break;
    case "boolean":
      hash = hashCodeNumber(obj | 0, hash);
      break;
    case "string":
      hash = hashCodeString(obj, hash);
      break;
    default:
      hash = hashCodeNumber(0, hash);
      break;
  }

  return hash;

}